import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AsyncPipe, NgClass } from '@angular/common';
import { DeviceDetectorService } from '@core/services';
import { TranslatePipe } from '@ngx-translate/core';
import { environment } from '@environment/environment';

@Component({
  selector: 'x-payroll',
  imports: [AsyncPipe, NgClass, TranslatePipe],
  templateUrl: './payroll.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PayrollComponent {
  readonly deviceService = inject(DeviceDetectorService);
  private readonly domSanitizer = inject(DomSanitizer);

  readonly payrollIframeSrc: SafeResourceUrl =
    this.domSanitizer.bypassSecurityTrustResourceUrl(
      `${environment.accountingIframeUrl}/accrualReport`,
    );
}
